module.exports = __webpack_public_path__ + "static/media/newspaper.72cf49aa.svg";